import { ApiError } from "./ApiError";

export class BadRequestException extends ApiError {
    
}